<template>
    <div class="card message-comp">
        <div class="card-header message-comp-header bg-ums text-center cursor-pointer" @click="show = !show" v-if="!modify">
            <i class="icon-plus-circle2"/>
        </div>
        <div class="card-header message-comp-header" v-else>
            <div class="table-responsive">
                <table class="table">
                    <tbody>
                    <tr @click="show = !show" class="cursor-pointer">
                        <td style="width: 15%" class="text-center"><span class="badge message-badge" :class="'badge-'+info.msgType">{{getBadge(info.msgType)}}</span></td>
                        <td style="width: 15%" class="text-center">{{info.tmplId}}</td>
                        <td style="width: 35%">
                            <div  class="td-ellipsis">{{info.tmplContent?info.tmplContent.replace(/<\s*br[^>]*>/g,' '):''}}</div>
                        </td>
                        <td style="width: 5%" class="text-center">{{info.paramCnt}}</td>
                        <td style="width: 15%" class="text-center">{{info.lang}}</td>
                        <td style="width: 5%" v-if="(info.msgType === $const.MSG_TYPE.SMS || info.msgType === $const.MSG_TYPE.MAIL) && hasRole($const.ROLES.TEMPLATE_TEST_SEND)" @click="openSendTestModal(info,$event)">
                            <button  class="option-icon-padding btn">
                                <i class="icon-paperplane icon-1x"/>
                            </button>
                        </td>
                        <td style="width: 5%" v-else/>
                        <td style="width: 5%" @click="deleteTemplateInEvent(info,$event)" v-if="hasRole($const.ROLES.TEMPLATE_DELETE)">
                            <button  class="option-icon-padding btn">
                                <i class="icon-trash icon-1x"/>
                            </button>
                        </td>
                        <td style="width: 5%"><i :class="{'icon-arrow-up15':show,'icon-arrow-down15':!show}"/></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <transition name="slide-fade">
            <div class="card-body" v-if="show" style="background-color: #F8F8F8;">
                <template-editor :queue-type="queueType" :messageInfo="info" @templateUpdated="templateUpdated"/>
            </div>
        </transition>
        <send-modal :target="modalTarget" :modalData="modalData"/>
    </div>
</template>

<script>
    import TemplateEditor from "@/page/template/event/TemplateEditor";
    import api from "@/api/template"
    import SendModal from "@/components/modal/SendModal";
    export default {
        name: "MessageComp",
        components: {SendModal, TemplateEditor},
        props:{
            queueType: {
                type: String,
                required: false
            },
            info: {
                type: Object,
                required: true
            },
            modify: {
                type:Boolean,
                default: true
            },
        },
        data() {
            return {
                modalTarget: 'sendTest'+ this._uid,
                modalData:[],
                badge: 'Mail',
                show: false
            }
        },
        computed: {
            storedEventInfo: function() {
                return this.$store.getters[this.$const.GETTERS.STORED_EVENT_INFO]()
            }
        },
        methods: {
            templateUpdated: function() {
                this.show = false
            },
            openSendTestModal: function(info,event) {
                event.stopPropagation()
                this.modalData = info
                this.modalData.clientCd = this.storedEventInfo.clientCd
                this.modalData.addParamSubjYn = this.storedEventInfo.addParamSubjYn == null ? "" : this.storedEventInfo.addParamSubjYn
                $('#'+this.modalTarget).modal('toggle')
            },
            deleteTemplateInEvent: function(item,event) {
                event.stopPropagation()
                this.$notify.warningConfirm(item.tmplId,()=> {
                    api.deleteTemplateInEvent(item.tmplId).then((result)=>{
                        if(result && result.data.code === 1000) {
                            this.$notify.success('Success')
                            this.$store.dispatch(this.$const.ACTIONS.CALL_EVENT_INFO,{eventId: this.storedEventInfo.eventId})
                        } else {
                            this.$notify.alert(result.data.message)
                        }
                    })
                })
            },
            getBadge(type) {
                let badge = 'MAIL'
                switch (type) {
                    case this.$const.MSG_TYPE.SMS : badge = 'SMS'
                        break;
                    case this.$const.MSG_TYPE.MAIL : badge = 'MAIL'
                        break;
                    case this.$const.MSG_TYPE.APP_PUSH : badge = 'LINE PUSH'
                        break;
                    case this.$const.MSG_TYPE.LINE_OA : badge = 'OA'
                        break;
                    case this.$const.MSG_TYPE.LINE_1TO1 : badge = 'LINE 1 TO 1'
                        break;
                    case this.$const.MSG_TYPE.NOTIFICATION : badge = 'NOTIFICATION'
                        break;
                    default: badge = 'MAIL'
                }
                return badge
            }
        }
    }
</script>

<style scoped>
    .message-comp {
        margin-bottom: 0.25rem;
    }
    .table td {
        padding : 0px
    }
    .message-comp-header {
        padding-top:0.8rem !important;
        padding-bottom:0.8rem !important;
    }
    .message-badge {
        width: 7rem;
        font-size: 0.7rem;
    }

    .message-comp .card-body {
        padding-top:1rem !important;
        border-top: 1px solid #ddd;
    }
    /* 애니메이션 진입 및 진출은 다른 지속 시간 및  */
    /* 타이밍 기능을 사용할 수 있습니다. */
    .slide-fade-enter-active {
        transition: all .3s ease-in-out;
    }
    .slide-fade-leave-active {
        transition: all .3s ease-in-out;
    }
    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */ {
        transition: all .3s ease-in-out;
        opacity: 0;
    }
    .badge-1 {
        color:#fff;
        background-color:#2196f3;border-color:#2196f3
    }
    .badge-2 {
        color:#fff;
        background-color:#4caf50;border-color:#4caf50
    }
    .badge-3 {
        color:#fff;
        background-color:#00bcd4;border-color:#00bcd4
    }
    .badge-4 {
        color:#fff;
        background-color:#ff5722;border-color:#ff5722
    }
    .badge-5 {
        color:#fff;
        background-color: #006a23;border-color:#006a23
    }
    .badge-9 {
        color:#fff;
        background-color: #af9609;border-color:#af9609
    }
    .td-ellipsis {
        width: calc(100vw - 100vw* 0.7);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: block;
    }
</style>
